<template>
  <iframe
    src="https://donate.raisenow.io/vyqgs?lng=de"
    width="100%"
    frameborder="0"
  />
</template>

<style scoped>
iframe {
  height: 1800px;

  @screen md {
    height: 2000px;
  }
}
</style>
